function initSlider(slider, nextButton, prevButton) {
  new Swiper(slider, {
    slidesPerView: 4,
    spaceBetween: 33,
    keyboard: {
      enabled: true,
    },
    breakpoints: {
      // when window width is >= 320px
      320: {
        slidesPerView: 1.7,
        spaceBetween: 23,
      },
      // when window width is >= 768px
      768: {
        slidesPerView: 3.3,
        spaceBetween: 24,
      },
      // when window width is >= 992px
      992: {
        slidesPerView: 4,
        spaceBetween: 24,
      },
      // when window width is >= 1335px
      1335: {
        slidesPerView: 4,
        spaceBetween: 33,
      },
    },
    navigation: {
      nextEl: nextButton,
      prevEl: prevButton,
    },
    on: {
      init: function () {
        const checkInterval = setInterval(() => {
          const links = document.querySelectorAll('#main-container .list-rec a');
          
          if (links.length > 0) {
            clearInterval(checkInterval);
            processProductLabels();
          }
        }, 500);
      },
    },
  });
}

function initSliderCart(slider, nextButton, prevButton) {
  new Swiper(slider, {
    slidesPerView: 4,
    spaceBetween: 33,
    keyboard: {
      enabled: true,
    },
    breakpoints: {
      // when window width is >= 320px
      320: {
        slidesPerView: 2.2,
        spaceBetween: 13,
      },
      // when window width is >= 768px
      768: {
        slidesPerView: 3.3,
        spaceBetween: 24,
      },
      // when window width is >= 992px
      992: {
        slidesPerView: 4,
        spaceBetween: 24,
      },
      // when window width is >= 1335px
      1335: {
        slidesPerView: 4,
        spaceBetween: 33,
      },
    },
    navigation: {
      nextEl: nextButton,
      prevEl: prevButton,
    },
    on: {
      init: function () {
        const checkInterval = setInterval(() => {
          const links = document.querySelectorAll('#main-container .list-rec a');
          
          if (links.length > 0) {
            clearInterval(checkInterval);
            processProductLabels();
          }
        }, 500);
      },
    },
  });
}

function initSliderDrawer(slider) {
  new Swiper(slider, {
    slidesPerView: 2.8,
    spaceBetween: 12,
    keyboard: {
      enabled: true,
    },
    on: {
      init: function () {
        const checkInterval = setInterval(() => {
          const links = document.querySelectorAll('.cart-drawer .list-rec a');
          
          if (links.length > 0) {
            clearInterval(checkInterval);
            processProductLabels();
          }
        }, 500);
      },
    },
  });
}

function processProductLabels() {

  document.querySelectorAll(".list-rec__product a[data-tags]").forEach((link) => {
    const dataTags = link.getAttribute("data-tags");

    if (link.hasAttribute("data-tags")) {
      link.removeAttribute("data-tags");
    }

    if (!dataTags) return;

    const tags = dataTags.split(",");
    let labelText = "";

    tags.forEach((tag) => {
      if (tag.includes("label_")) {
        const labelParts = tag.split("_");
        if (labelParts.length > 1) {
          const labelValue = labelParts.slice(1).join(" ");
          const formattedLabel = labelValue
            .replace(/_/g, " ")
            .replace(/-/g, " ")
            .toLowerCase();
          labelText += `<span class="product-label">${formattedLabel}</span>`;
        }
      }
    });

    if (labelText) {
      const labelContainer = document.createElement("div");
      labelContainer.classList.add("product-labels");
      labelContainer.innerHTML = labelText;

      link.prepend(labelContainer);
    }
  });

  //update price
  if (window.ShopCurrency && window.ShopCurrency.symbol.includes('$') && window.ShopCurrency.iso_code !== 'USD') {
    document.querySelectorAll(".list-rec__product .list-rec__price").forEach((el) => {
      if (!el.textContent.includes(window.ShopCurrency.iso_code)) {
        el.textContent = el.textContent.trim() + ' ' + window.ShopCurrency.iso_code;
      }
    });
  }
}

function initListrak() {
  const containers = document.querySelectorAll(".listrak-overflow");

  if (containers.length && typeof _ltk !== "undefined") {
    /********** Begin Custom Code **********/
    _ltk.Recommender.AddField("Meta2");
    _ltk.Recommender.AddField("Meta3");
    _ltk.Recommender.AddField("Sku");
    _ltk.Recommender.Render();

    containers.forEach((container) => {
      container.setAttribute("style", "position: relative;");
      container.classList.remove("listrak-overflow");
      const slider = container.querySelector(".list-rec__slider");
      const nextButton = container.querySelector(".swiper-button-next");
      const prevButton = container.querySelector(".swiper-button-prev");

      if (slider) {
        if (container.classList.contains("mrk-recomend")) {
          initSliderDrawer(slider, nextButton, prevButton);
        } else if (
          !container.classList.contains("mrk-recomend") &&
          document.body.classList.contains("template--cart")
        ) {
          initSliderCart(slider, nextButton, prevButton);
        } else {
          initSlider(slider, nextButton, prevButton);
        }
      }
    });
  }
}


window.initListrak = initListrak;

(function (d) {
  if (document.addEventListener)
    document.addEventListener("ltkAsyncListener", d);
  else {
    e = document.documentElement;
    e.ltkAsyncProperty = 0;
    e.attachEvent("onpropertychange", function (e) {
      if (e.propertyName == "ltkAsyncProperty") {
        d();
      }
    });
  }
})(function () {
  /********** Begin Custom Code **********/
  document.body.classList.add("listrak-load");
  if (Shopify.designMode) {
    initListrak();
    document.addEventListener("shopify:section:load", function (event) {
      if (event.srcElement.className.includes("listrak-overflow")) {
        initListrak();
      }
    });
  } else {
    initListrak();
  }
});
